export const EMPLOYEE = 'Employee';
export const OWNER = 'Owner';
export const CANDIDATE_ID = 4;
